import { message } from 'antd';
import { AxiosError } from 'axios';
import { Dispatch } from 'redux';
import { setCartLoading, updateCartData } from 'appRedux/actions';
import { ApiClient } from 'services/ApiClient';
import { ICartEmptyResponse, ICartResponse, INft } from 'interfaces';

// == CART

export const addToCart = (id: INft['id']) => {
  return async (dispatch: Dispatch) => {
    dispatch(setCartLoading());
    try {
      const { data } = await ApiClient.post<ICartResponse>(
        `/checkout/cart/add/${id}`
      );
      return dispatch(updateCartData(data.data));
    } catch (error) {
      if (error instanceof AxiosError) {
        const errorMessage = error?.response?.data?.message;
        message.error(errorMessage);
        return dispatch(setCartLoading(false));
      } else if (error instanceof Error) {
        message.error(error.message);
        return dispatch(setCartLoading(false));
      } else {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
  };
};

export const bulkAddToCart = (ids: INft['id'][]) => {
  return async (dispatch: Dispatch) => {
    dispatch(setCartLoading());
    try {
      const { data } = await ApiClient.post<ICartResponse>(
        `/checkout/cart/bulk-add`,
        {
          ids: ids
        }
      );
      return dispatch(updateCartData(data.data));
    } catch (error) {
      if (error instanceof AxiosError) {
        const errorMessage = error?.response?.data?.message;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
        return dispatch(setCartLoading(false));
      } else if (error instanceof Error) {
        // eslint-disable-next-line no-console
        console.error(error.message);
        return dispatch(setCartLoading(false));
      } else {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
  };
};

export const removeFromCart = (id: INft['id']) => {
  return async (dispatch: Dispatch) => {
    dispatch(setCartLoading());
    try {
      const { data } = await ApiClient.delete<ICartResponse>(
        `/checkout/cart/remove/${id}`
      );
      return dispatch(updateCartData(data.data));
    } catch (error) {
      if (error instanceof AxiosError) {
        const errorMessage = error?.response?.data?.message;
        message.error(errorMessage);
        return dispatch(setCartLoading(false));
      } else if (error instanceof Error) {
        message.error(error.message);
        return dispatch(setCartLoading(false));
      } else {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
  };
};

export const removeBulkFromCart = (ids: INft['id'][]) => {
  return async (dispatch: Dispatch) => {
    dispatch(setCartLoading());
    try {
      const { data } = await ApiClient.delete(`/checkout/cart/bulk-remove`, {
        params: {
          cart_item_ids: ids
        }
      });
      return dispatch(updateCartData(data.data));
    } catch (error) {
      if (error instanceof AxiosError) {
        const errorMessage = error?.response?.data?.message;
        message.error(errorMessage);
        return dispatch(setCartLoading(false));
      } else if (error instanceof Error) {
        message.error(error.message);
        return dispatch(setCartLoading(false));
      } else {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
  };
};

export const emptyCart = () => {
  return async (dispatch: Dispatch) => {
    dispatch(setCartLoading());
    try {
      await ApiClient.delete<ICartEmptyResponse>(`/checkout/cart/empty`);
      return dispatch(updateCartData());
    } catch (error) {
      if (error instanceof AxiosError) {
        const errorMessage = error?.response?.data?.message;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
        return dispatch(setCartLoading(false));
      } else if (error instanceof Error) {
        // eslint-disable-next-line no-console
        console.error(error.message);
        return dispatch(setCartLoading(false));
      } else {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
  };
};

export const getCart = () => {
  return async (dispatch: Dispatch) => {
    dispatch(setCartLoading());
    try {
      const { data } = await ApiClient.get<ICartResponse>(`/checkout/cart`);
      return dispatch(updateCartData(data.data));
    } catch (error) {
      if (error instanceof AxiosError) {
        const errorMessage = error?.response?.data?.message;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
        return dispatch(setCartLoading(false));
      } else if (error instanceof Error) {
        // eslint-disable-next-line no-console
        console.error(error.message);
        return dispatch(setCartLoading(false));
      } else {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
  };
};
